import React, { useState, useEffect, useRef } from 'react';

export default function SearchBar({ value, onChange, placeholder = 'Buscar...' }) {
  const [local, setLocal] = useState(value || '');
  const timer = useRef(null);

  useEffect(() => {
    setLocal(value || '');
  }, [value]);

  useEffect(() => {
    return () => clearTimeout(timer.current);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocal(val);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange(val), 400);
  };

  return (
    <div className="search-bar">
      <span className="search-bar-icon">{'\u2315'}</span>
      <input
        type="text"
        placeholder={placeholder}
        value={local}
        onChange={handleChange}
      />
    </div>
  );
}
